module.exports = __webpack_public_path__ + "img/no_shop.f03c79cb.png";